var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.6002 3.4999C5.6002 3.31425 5.67395 3.1362 5.80522 3.00493C5.9365 2.87365 6.11454 2.7999 6.3002 2.7999H14.7002C14.8858 2.7999 15.0639 2.87365 15.1952 3.00493C15.3264 3.1362 15.4002 3.31425 15.4002 3.4999V17.4999C15.4002 17.6856 15.3264 17.8636 15.1952 17.9949C15.0639 18.1262 14.8858 18.1999 14.7002 18.1999H6.3002C6.11454 18.1999 5.9365 18.1262 5.80522 17.9949C5.67395 17.8636 5.6002 17.6856 5.6002 17.4999V3.4999ZM6.3002 1.3999C5.74324 1.3999 5.2091 1.62115 4.81527 2.01498C4.42144 2.4088 4.2002 2.94295 4.2002 3.4999V17.4999C4.2002 18.0569 4.42144 18.591 4.81527 18.9848C5.2091 19.3787 5.74324 19.5999 6.3002 19.5999H14.7002C15.2572 19.5999 15.7913 19.3787 16.1851 18.9848C16.5789 18.591 16.8002 18.0569 16.8002 17.4999V3.4999C16.8002 2.94295 16.5789 2.4088 16.1851 2.01498C15.7913 1.62115 15.2572 1.3999 14.7002 1.3999H6.3002ZM8.4002 16.3099C8.27024 16.3099 8.14561 16.3615 8.05371 16.4534C7.96182 16.5453 7.9102 16.6699 7.9102 16.7999C7.9102 16.9299 7.96182 17.0545 8.05371 17.1464C8.14561 17.2383 8.27024 17.2899 8.4002 17.2899H12.6002C12.7302 17.2899 12.8548 17.2383 12.9467 17.1464C13.0386 17.0545 13.0902 16.9299 13.0902 16.7999C13.0902 16.6699 13.0386 16.5453 12.9467 16.4534C12.8548 16.3615 12.7302 16.3099 12.6002 16.3099H8.4002Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsMobile);
export default __webpack_public_path__ + "static/media/icons_mobile.3ff19d565501a960b59f407c6d142547.svg";
export { ForwardRef as ReactComponent };